<template>
<div class="chapter">
<div class="inner_page">
<div id="Copyright" style="font-size:75%;">
<p class="space"> </p>
<p class="copy">ISBN: 978 1 47384 547 3<br/>
PDF ISBN: 978 1 47384 550 3<br/>
EPUB ISBN: 978 1 47384 549 7<br/>
PRC ISBN: 978 1 47384 548 0</p>
<p class="copy1">Price £9.99</p>
<p class="copy1">Pen &amp; Sword Books Ltd<br/>47 Church Street<br/>Barnsley S70 2AS</p>
<p class="copy1">Telephone: 01226-734222 Fax: 01226-734438<br/><a href="http://www.pen-and-sword.co.uk" target="_blank">www.pen-and-sword.co.uk</a></p>
<p class="copy1">© R&amp;F Defence Publications</p>
<p class="copy1">The Information in this publication has been gathered from unclassified sources.</p>
<p class="copy1">Front Cover: T Hawk UAV clearing a route of improvised explosive devices as part of the ‘Talisman’ route clearance system. (Copyright MoD 2015)</p>
<p class="copy1">Rear Cover: Soldier manning a .50 cal heavy machine gun mounted on a Jackal 2 All Terrain Vehicle. (Copyright MoD 2015)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?588ee8b0